import { Button, Field } from '@/components'
import styles from './styles.module.scss'

import useFormSoftlead from './hooks'
import { inputValidations } from './inputValidations'

const FormSoftlead = ({
  className = '',
  productId,
  planId = null,
  selectOptions,
  isFormWithSelect = false,
  formTitle = 'Experimente por 7 dias. Comece agora!',
  formCtaText = 'PROSSEGUIR',
  variant,
  secondaryVariant,
  isSubscriberFlow = false
}) => {
  const { control, handleSubmit, onSubmit, clearErrors, isLoading } =
    useFormSoftlead({
      productId,
      planId,
      selectOptions,
      isFormWithSelect,
      isSubscriberFlow
    })

  return (
    <div className={styles.softlead} id="formSoftlead">
      <div className={`${styles.softlead__content} ${className}`}>
        <h2 className={styles.softlead__title}>{formTitle}</h2>
        <form
          className={styles.softlead__form}
          onSubmit={handleSubmit(onSubmit)}
        >
          <Field.Input.Text
            name="name"
            label={'Nome e sobrenome'}
            control={control}
            onFocus={() => clearErrors('name')}
            type="text"
            rules={inputValidations.name}
          />
          <Field.Input.Email
            name="email"
            label={'E-mail'}
            control={control}
            onFocus={() => clearErrors('email')}
            rules={inputValidations.email}
          />
          <Field.Input.Phone
            name="phone"
            label={'Telefone'}
            control={control}
            onFocus={() => clearErrors('phone')}
            rules={inputValidations.phone}
          />
          {isFormWithSelect && (
            <Field.Select
              name="productType"
              control={control}
              options={selectOptions}
              label={'Escolha um plano'}
              className={styles.softlead__select}
            />
          )}
          <Button
            type="submit"
            disabled={isLoading}
            isLoading={isLoading}
            className={styles.submitButton}
            variant={variant}
            textColor={secondaryVariant}
          >
            {formCtaText}
          </Button>
        </form>
        <p className={styles.softlead__disclaimer}>
          Ao continuar estou ciente e de acordo com o{' '}
          <a
            href="https://academiafoguete.com.br/politica-de-privacidade"
            target="_blank"
          >
            Termo privacidade
          </a>{' '}
          e{' '}
          <a
            href="https://academiafoguete.com.br/termos-e-condicoes"
            target="_blank"
          >
            Termos e condições
          </a>{' '}
          e uso de dados da Academia Foguete.
        </p>
      </div>
    </div>
  )
}

export default FormSoftlead
